import { ExportData, Status } from './types';

export const defaultExportData: ExportData = {
  media: null,
  status: Status.PENDING
};
